export const getGameTeamRosters = (rosters, homeTeamId, visitingTeamId) => {
  let home = null,
    visiting = null

  rosters?.forEach((roster) => {
    if (roster.team_id === homeTeamId) {
      home = roster
    } else if (roster.team_id === visitingTeamId) {
      visiting = roster
    }
  })

  return { homeGameRoster: home, visitingGameRoster: visiting }
}
